import { useCallback, memo } from 'react';
import { Select, ClearIcon } from '@attentive-platform/stem-ui';

export const TradeNameCell = memo(({ id, trade, onTradeChange, options, isOptionDisabled }) => {
  const handleChange = useCallback(
    value => {
      onTradeChange(id, value);
    },
    [id, onTradeChange]
  );

  return (
    <Select
      disableOption={isOptionDisabled}
      placeholder='Select Trade'
      color='primary'
      items={options}
      value={trade}
      onChange={handleChange}
    />
  );
});

export const WorkflowCell = memo(({ id, workflows, onWorkflowChange, options }) => {
  const handleChange = useCallback(
    value => {
      onWorkflowChange(id, value);
    },
    [id, onWorkflowChange]
  );

  return (
    <Select
      placeholder='Select takeoff type'
      color='primary'
      items={options}
      multiple
      value={workflows}
      onChange={handleChange}
    />
  );
});

export const ActionCell = memo(({ id, onDeleteTrade }) => {
  const handleClick = useCallback(() => {
    onDeleteTrade(id);
  }, [id, onDeleteTrade]);

  return (
    <button className='p-0 bg-transparent border-0' onClick={handleClick}>
      <ClearIcon fill='var(--color-error-50)' />
    </button>
  );
});
